import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removebraces',
    standalone: true,
})
export class RemoveBracesPipe implements PipeTransform {
    transform(value: string | undefined): string {
        if (!value) return '';
        return value.replace(/\{+.*?\}+/, '');
    }
}
